import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';

import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import UIState from './contexts/ui/UIState';
import AuthProvider from './contexts/auth/AuthProvider';
import ProcessProvider from './contexts/process/ProcessState';
import TicketsProvider from './contexts/tickets/TicketsProvider';
import SessionInformationProvider from './contexts/session-information/SessionInformationProvider';
import './index.scss';
import { Amplify } from "aws-amplify";
import { awsconfig } from "./aws-config/awsconfig";
import { bootstrapMaintenanceOrRedirectAsync } from "./maintenance/bootstrapMaintenance";
import { Hub } from 'aws-amplify/utils';

const rootElement = document.getElementById('root');
console.log("FarmerApp is starting!");
console.log("DEBUG: Current URL:", window.location.href);
console.log("DEBUG: Bypass Active:", sessionStorage.getItem("maintenance:ignore"));

Amplify.configure(awsconfig);

const authRedirectKey = "auth:postLoginRedirect";

Hub.listen("auth", ({ payload }) => {
  if (payload?.event !== "customOAuthState") {
    return;
  }

  const redirectPath = payload?.data;
  if (typeof redirectPath !== "string" || redirectPath.length === 0) {
    return;
  }

  sessionStorage.setItem(authRedirectKey, redirectPath);
});

const router = createBrowserRouter([
    {
        path: '/*',
        element: <App />
    }
], {
    future: {
        v7_startTransition: true,
        v7_relativeSplatPath: true,
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_skipActionErrorRevalidation: true,
    },
});

console.log(`Version: ${import.meta.env.VITE_VERSION_TEXT}`);

async function start() {
    try {
        /**
         * STEP 1: Maintenance check & bypass logic
         *
         * bootstrapMaintenanceOrRedirectAsync internally performs:
         * 1. Checks if a bypass token is present in the URL/bridge.
         *    → If yes: return immediately (do nothing).
         * 2. If no bypass token is found:
         *    → Performs an API call to BackendStateApiService.
         * 3. If maintenance mode is active:
         *    → Redirects via window.location.href to the maintenance page
         *      (hard redirect).
         */
        await bootstrapMaintenanceOrRedirectAsync();

        /**
         * STEP 2: Render application
         *
         * This code is executed ONLY if:
         * - Maintenance mode is NOT active, OR
         * - The user has a valid bypass token.
         */
        ReactDOM.createRoot(rootElement).render(
            <UIState>
                <SessionInformationProvider>
                    <AuthProvider>
                        <ProcessProvider>
                            <TicketsProvider>
                                <RouterProvider router={router} />
                            </TicketsProvider>
                        </ProcessProvider>
                    </AuthProvider>
                </SessionInformationProvider>
            </UIState>
        );
    } catch (error) {
        /**
         * ERROR HANDLING:
         *
         * If the maintenance check fails (e.g. backend is unreachable),
         * redirect to the maintenance page as a safe fallback.
         */
        console.error("Critical error during app startup check:", error);
        window.location.href = import.meta.env.VITE_PATH_TO_MAINTENANCE_PAGE;
    }
}

start();